module.exports = __webpack_public_path__ + "img/treasure-home-logo.513e1668.png";